import React from 'react'
import PaginationDot from './PaginationDot'

type Props = {
  dots: number
  index: number
  onChangeIndex: Function
}

const Pagination: React.FC<Props> = ({ dots, index, onChangeIndex }) => {
  const handleClick = (event, index) => {
    onChangeIndex(index)
  }

  const children = []

  for (let i = 0; i < dots; i += 1) {
    children.push(<PaginationDot key={i} index={i} active={i === index} onClick={handleClick} />)
  }

  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        bottom: 8,
        right: 8,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      {children}
    </div>
  )
}

export default Pagination
